import MoreDetailsLayout from './MoreDetailsLayout';
import {useRef} from "react";
import {
    setSubscriptionToDetails,setSubscriptionToQuote,
    updateGUIInstrumentsToBackend, updateTickerSubscriptionWithKite
} from "../../../services/apiService";  // Adjust the path according to your file structure

export const handleShowDetails = (GUIInstrument, setGUIInstruments, setLayouts, tabID,itemIndex,height ) => {
    const targetHeight = 10.2;

    // Toggle logic: If the item already has additional data, remove it; otherwise, add the grid layout
        if (GUIInstrument.isDetailsVisible) {
            /*console.log("handleShowDetails2222222");*/
            /*delete clickedInstrument.moreDetails;  // Remove the additional data*/
            GUIInstrument.isDetailsVisible = false;  // Mark details as hidden
            setSubscriptionToQuote(GUIInstrument.instrumentToken,"tabID:" +tabID);
            setLayouts((prevLayouts) => {
                const updatedLayouts = prevLayouts.map((item, index) =>
                    index === itemIndex
                        ? { ...item, h: 1 } // Update the height dynamically
                        : item
                );
                /*console.log("22222Updated layout with dynamic height:", updatedLayouts);*/
                return updatedLayouts;
            });
        } else {
            setSubscriptionToDetails(GUIInstrument.instrumentToken,"tabID:"+tabID);
            setLayouts((prevLayouts) => {
                const updatedLayouts = prevLayouts.map((item, index) =>
                    index === itemIndex
                        ? { ...item, h: targetHeight } // Update the height dynamically
                        : item
                );
                /*console.log("22222Updated layout with dynamic height:", updatedLayouts);*/
                return updatedLayouts;
            });
            GUIInstrument.isDetailsVisible = true;  // Mark details as visible
        }
    // Now update the entire GUIInstruments array, replacing the modified instrument
    setGUIInstruments(prevGUIInstruments => prevGUIInstruments);
};

// Utility function to generate random sentences
export const generateRandomSentence = () => {
    const sentences = [
        "This is a random sentence.",
        "Another small random sentence.",
        "Here's some random text.",
        "Randomness at its best.",
        "Simple and short.",
        "Generated text for demo.",
        "Smooth and simple writing.",
        "Text to fill the space.",
        "Another random line here.",
        "Last but not least."
    ];
    return sentences[Math.floor(Math.random() * sentences.length)];
};